import React, { useMemo } from "react";
import { accordion } from "../CommonForm/CommonFormInterface";

const Accordion = ({
  field,
  children,
}: {
  field: accordion;
  children: React.ReactNode;
}) => {
  
  return <div id="accordion-group">{children}</div>;
};

export default Accordion;
